import { useState } from "react"
import { hasValue } from "../../helpers/nullable"
import SelectTenantView from "./SelectTenantView"
import TenantForm from "./TenantForm"
import { TenantsContextWrapper } from "./TenantsContext"
import TenantsSidebar from "./TenantsSidebar"

type Props = {
  heroImage: string
  publicBucketName: string
  tenantId?: number
}

const TenantsPageContent = ({ heroImage, publicBucketName, tenantId }: Props) => {
  const [selectedTenantId, setSelectedTenantId] = useState<number | undefined>(tenantId)
  const [hasTenantChanged, setHasTenantChanged] = useState(false)

  const handleTenantSelect = (tenantId: number) => {
    if (hasTenantChanged && hasValue(selectedTenantId)) {
      if (!window.confirm('This tenant has been edited.\n\nDiscard your changes and select a different tenant?')) {
        return
      }
    }

    setSelectedTenantId(tenantId)
  }

  const pageContent = !hasValue(selectedTenantId)
    ? <SelectTenantView />
    : <TenantForm heroImage={heroImage} onTenantSavedSuccessfully={setSelectedTenantId} />

  return <>
    <TenantsContextWrapper
      tenantId={selectedTenantId}
      bucketName={publicBucketName}
      onTenantChange={setHasTenantChanged}
    >
      <TenantsSidebar onTenantSelect={handleTenantSelect} publicBucketName={publicBucketName} />
      {pageContent}
    </TenantsContextWrapper>
  </>
}

export default TenantsPageContent